module.exports = __webpack_public_path__ + "static/img/Sprite.4136f531.png";